import React from 'react';
import SelectableProvider from 'core/context/selectable';
import Dialog from 'pages/Dashboard/pages/Fax/Overview/AddPatientForm';

export type AddPatientDialogProps = {
  open: boolean;
  onClose: () => void;
  id: number;
};

export type AddPatientDialogParams = {
  id: number;
};

export default function AddPatientDialog({
  open,
  onClose,
  id,
}: AddPatientDialogProps) {
  return (
    <SelectableProvider>
      <Dialog
        open={open}
        onClose={onClose}
        id={id}
      />
    </SelectableProvider>
  );
}
